<template>
  <div class="title">
    <div class="title_box">
      <div class="title_logo">
        <a class="navbar-brand" href="#">
          <img
            src="../../assets/images/logo.png"
            width="100"
            class="logo"
            alt=""
          />
        </a>
      </div>
      <div class="title_ul">
          <!-- <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
          default-value="first"
        >
          <el-tab-pane label="首页" name="home" key="home"></el-tab-pane>
          <el-tab-pane label="产品" name="product" key="product"></el-tab-pane>
          <el-tab-pane label="案例中心" name="case" key="case"></el-tab-pane>
          <el-tab-pane
            label="新闻动态"
            name="journalism"
            key="journalism"
          ></el-tab-pane>
          <el-tab-pane
            label="关于点甜"
            name="about"
            key="aboutlina"
          ></el-tab-pane>
          <el-tab-pane
            label="联系我们"
            name="ContactUs"
            :key="ContactUs"
          ></el-tab-pane>
        </el-tabs> -->
        <ul>
          <li
            :class="NowPath == 1000 ? 'lis_line' : 'lis'"
            @click="toHome"
            @mouseout="closeHom"
          >
            首页
          </li>
          <li
            class="lis"
            :class="NowPath == 999.1 ? 'lis_line' : 'lis'"
            @click="toProductList"
          >
            产品
          </li>
          <li
            class="lis"
            :class="NowPath == 999.2 ? 'lis_line' : 'lis'"
            @click="toCaseCenter"
          >
            案例中心
          </li>
          <li
            :class="NowPath == 999.3 ? 'lis_line' : 'lis'"
            @click="toMediaCenter"
          >
            新闻动态
          </li>
          <li
            :class="NowPath == 999.4 ? 'lis_line' : 'lis'"
            class="lis"
            @click="toAboutUs"
          >
            关于点甜
          </li>
          <li
            :class="NowPath == 999.5 ? 'lis_line' : 'lis'"
            @click="toContactUs"
          >
            联系我们
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { GetDeviceSeries } from "@/api/api";
import { ElMessage } from "element-plus";

export default defineComponent({
  name: "TitleCom",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const showPro = ref(false); //产品下拉框
    const showAbo = ref(false); //关于我们下拉框
    const showInfo = ref(false); //新闻资讯
    const NowPro = ref(1); //标红文字
    const NowPath = ref(1); //标红文字

    const activeName = ref("home");

    const ProductList = ref([]); //筛选有子产品的系列
    console.log(NowPath.value);

    // 1. 首次挂载时设置一次
    onMounted(() => {
      const name = route.name;
      console.log(name, "路由信息");
      if (name == "home") {
        NowPath.value = 1000;
      } else if (name == "ProductList") {
        NowPath.value = 999.1;
      } else if (name == "CaseCenter") {
        NowPath.value = 999.2;
      } else if (name == "MediaCenter") {
        NowPath.value = 999.3;
      } else if (name == "AboutUs") {
        NowPath.value = 999.4;
      } else if (name == "ContactUs") {
        NowPath.value = 999.5;
      }
    });

    // 首页 点击变红
    function showHom() {
      if (NowPath.value != 1000) {
        NowPath.value = 1000;
      }
    }

    // 首页 点击变红
    function showHom() {
      if (NowPath.value != 1000) {
        NowPath.value = 1000;
      }
    }

    // 首页 点击变红
    function closeHom() {
      const name = route.name;
      if (name == "home") {
        NowPath.value = 1000;
      } else if (name == "ProductList") {
        NowPath.value = 999.1;
      } else if (name == "CaseCenter") {
        NowPath.value = 999.2;
      } else if (name == "MediaCenter") {
        NowPath.value = 999.3;
      } else if (name == "AboutUs") {
        NowPath.value = 999.4;
      } else if (name == "ContactUs") {
        NowPath.value = 998.5;
      }
    }

    // 跳转 首页
    function toHome() {
      router.push({ path: "/" });
    }
    // 案例中心
    function toCaseCenter() {
      router.push({ path: "/CaseCenter" });
    }
    // 新闻动态
    function toMediaCenter() {
      router.push({ path: "/MediaCenter" });
    }
    // 关于点甜
    function toAboutUs() {
      router.push({ path: "/AboutUs" });
    }
    // 联系我们
    function toContactUs() {
      router.push({ path: "/ContactUs" });
    }

    // 产品
    function toProductList() {
      router.push({
        path: `/ProductList`,
      });
    }

    return {
      showPro,
      showAbo,
      showInfo,
      toHome,
      toContactUs,
      toMediaCenter,
      toAboutUs,
      toContactUs,
      toProductList,
      ProductList,
      NowPath,
      NowPro,
      activeName,
      showHom,
      closeHom,
      toCaseCenter,
    };
  },
});
</script>

<style scoped lang="less">
@import "@/components/styles/home/TitleCom.less";
</style>
